<script setup lang="ts">
import { Select } from '@taler/ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ASSIGNABLE_ROLES } from '../internal/roles.ts'
import type { LedgerRole } from '../internal/types.ts'

const model = defineModel<LedgerRole>({ required: true })
const props = defineProps<{ id: string; disabled?: boolean; ariaLabel?: string }>()

const { t } = useI18n()

const options = computed(() =>
  ASSIGNABLE_ROLES.map((role) => ({ value: role, label: t(`membership.roleName.${role}`) })),
)
</script>

<template>
  <div class="flex flex-col gap-[var(--space-tight)]">
    <Select
      :id="id"
      v-model="model"
      :options="options"
      :disabled="props.disabled ?? false"
      v-bind="props.ariaLabel === undefined ? {} : { ariaLabel: props.ariaLabel }"
    />
    <p class="text-[length:var(--text-step-2)] text-[color:var(--color-text-muted)]">
      {{ t(`membership.roleDescription.${model}`) }}
    </p>
  </div>
</template>
